import {gql} from "apollo-angular"

export const PROJECT_DD_CHECKLIST_GROUP_FRAGMENT = gql`
    fragment ProjectDdChecklistGroupFields on ProjectDdChecklistGroup {
      id
      projectDdChecklistSelections {
        id
        ddChecklistState {
          id
          name
        }
        ddChecklistItem {
          id
          name
          active
          ddChecklist {
            id
            name
          }
        }
        projectDdChecklistDates {
          ddChecklistState {
            name
            id
          }
          date
          id
        }
        projectDdChecklistDetailDates {
          date
          id
          ddChecklistDate {
            id
            name
          }
        }
      }
      project {
        id
        name
        sharepoint_folder
        projectStatuses {
          id
          status {
            id
            name
          }
          statusSequence {
            name
          }
        }
        projectDetail {
          lt_equity_amount
        }
        properties {
          entity {
            entityAddresses {
              address {
                id
                address1
                address2
                zipCode {
                  city
                  zipcode
                  state {
                    abbreviation
                  }
                }
              }
            }
          }
        }
        participants {
          role {
            name
          }
          person {
            id
            name
          }
          sponsor {
            name
            id
          }
        }
        pipelineProjects{
          id,
          active,
          pipelineProjectDates{
            id
            date
            initial_target
            target
            active
            pipelineMilestone {
              id
              milestone {
                name
              }
              milestoneStatus {
                id
              }
            }
          }
        }
        projectCredits {
          projectCreditOutlets {
            fund {
              id
              name
            }
          }
        }
        ltmodels(active_model: true){
          kpiset {
            kpiset_detail {
              net_operating_income
            }
          }
        }
      }
      timing_issues
      high_priority
      screening_delay
    }
`
export var get_dd_checklist_groups = gql`
  query getDdChecklistGroups($name: Mixed!){
    ddChecklistGroups(where: { column: NAME, operator: EQ, value: $name }){
      name
      ddChecklists {
        id
        name
        active
        ddChecklistItems {
          id
          name
          active
        }
      }
      projectDdChecklistGroups(active: true) {
        ...ProjectDdChecklistGroupFields
      }
    }
    ddChecklistDates {
      id
      name
    }
    ddChecklistStates {
      id
      name
    }
    me {
      id
      permissionsForResource(resourceType: DDCHECKLISTGROUP) {
        _create
        _read
        _edit
        _delete
        authorized_fields
      }
      user_profile {
        user {
          person {
            id
          }
        }
      }
    }
  }
  ${PROJECT_DD_CHECKLIST_GROUP_FRAGMENT}
  `

export var get_project_dd_checklist_group = gql`
    query projectDdChecklistGroup($id: ID!){
      projectDdChecklistGroup(id: $id){
        ...ProjectDdChecklistGroupFields
      }
    }
    ${PROJECT_DD_CHECKLIST_GROUP_FRAGMENT}
`
